/**
 * Created by Udara Prabath
 * Date: 10/29/2020
 * Using: IntelliJ IDEA
 */

import React from "react";
import './Lesson.scss'
import Header from "../../../components/Header/Header";
import {lang, language} from "../../../const/language";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import * as actionCreator from "../../../store/domain/classes/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as classService from "../../../services/class";
import * as lessonService from "../../../services/lessons";
import * as commonFunc from "../../../utils/commonFunc";
import * as constants from "../../../const/constants";
import LessonItem from "../../../components/LessonItem/LessonItemPurchase";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";
import NotFound from "../../../components/NotFound/NotFound";

class Lessons extends React.Component {

    state = {
        classId: '',
        lessons: [],
        customObject:[],
    }

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
        this.checkClass();
    }

    checkClass = async () => {
        let state = this.props.location.state;
        if (state) {
            this.props.spinnerHandler({isSpin: true, type: 10});
            await classService.getClassDetailsById(state)
                .then(async response => {
                    if (response.success) {
                        await this.setState({classId: response.body.id});
                        this.props.selectClassHandler(response.body);
                        await this.getAllLessons();
                    } else {
                        this.props.spinnerHandler(false);
                        commonFunc.notifyMessage(response.message, response.status);
                        this.goHome();
                    }
                })
        } else {
            this.goHome();
        }
    };

    goHome = () => {
        this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_INSTITUTE_ROUTE}`)
    };

    onBack = () => {
        window.history.back();
    }

    getAllLessons = async () => {
        await lessonService.getAllLessons(this.state.classId)
            .then(res => {
                this.props.spinnerHandler(false);
                let array = [];
                let customArray = [];

                if (res.success) {
                    array = res.body

                    array.map(obj => {
                        let yearObj;
                        if(customArray.length > 0) yearObj = customArray.find(yearObj => yearObj.year === obj.year);
                        if(yearObj === undefined) customArray.push({year: obj.year, months: []})

                        yearObj = customArray.find(yearObj => yearObj.year === obj.year);
                        let monthObj = yearObj.months.find(monthObj => monthObj.name === obj.month);
                        if(monthObj === undefined) yearObj.months.push({name: obj.month, lessons: []});

                        yearObj = customArray.find(yearObj => yearObj.year === obj.year);
                        monthObj = yearObj.months.find(monthObj => monthObj.name === obj.month);
                        monthObj.lessons.push({
                            ...obj
                        })
                    })
                    console.log("customArray",customArray)

                }
                this.setState({
                    customObject:customArray.reverse()
                });
            })
            .catch(error => {
                this.props.spinnerHandler(false);
                commonFunc.notifyMessage(error.message, error.status);
            })
    };

    render() {
        let {selectClass} = this.props;
        let firstWeek = new Date().getDate() <= 7;
        return (
            <div>
                <Header/>
                <main ref="main" className={"lessons"}>

                    <div className="lecture-intro">
                        <button className={"home-btn"}
                                onClick={() => this.onBack()}>
                            <i className="icofont-long-arrow-left"/>
                            {language[lang].BackToTour}
                        </button>
                    </div>
                    <div className="trapezoid "></div>
                    {
                        selectClass &&

                        <div className='ml-3 mr-3'>
                            <p className={"head-topic"}>{`${selectClass.name} - ${selectClass.subject}`}</p>
                            <p className={"head-teacher"}> by {`${selectClass.teacher.teacherName}`}</p>
                        </div>

                    }

                    {
                        this.state.customObject.length === 0 &&
                        <NotFound />
                    }

                    {this.state.customObject.map((value,index) => (
                        <section>
                            {value.months.reverse().map((month) => (
                                <section id="border-t"  className="align-items-center text-center mt-5">
                                    <h2 id="month-tag">{value.year}-{month.name}</h2>
                                    {
                                        selectClass  &&
                                        <LessonItem
                                            classId={selectClass.id}
                                            lessons={month.lessons}
                                            firstWeek={selectClass.firstWeekFree && firstWeek}/>
                                    }
                                </section>
                            ))}
                        </section>
                    ))

                    }

                </main>
                <CardsFooter />
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    selectClass: state.classes.selectClass,
});
const mapDispatchToProps = (dispatch) => ({
    selectClassHandler: data => dispatch(actionCreator.selectClass(data)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Lessons));